export enum ClaraMessageStatusType {
  CREATED = 'created',
  SUCCESS = 'success',
  NO_MATCH = 'no_match',
  NO_RELEVANCE = 'no_relevance',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  CLARIFICATION = 'clarification'
}
